import { PageContainer } from '../../components/layout';
import { Card } from '../../components/ui';
import buttonStyles from '../../components/ui/Button.module.css';
import manual from './manual-meta.json';
import styles from './HelpPage.module.css';

/**
 * HelpPage (13.1-11) — the Operator's Manual, under "More", for every QMS role.
 *
 * The manual has one source, `Harmony-QMS/onboarding/manual/`. `npm run manual:sync` copies it
 * into `public/manual/` (HTML, CSS, house fonts, screenshots, PDF) and writes `manual-meta.json`
 * (edition line, PDF size), so the manual deploys with the app and can't drift from it. Both
 * links are same-origin static files: the CSP stays 'self', and `staticwebapp.config.json`
 * keeps `/manual/*` out of the SPA fallback.
 */

const OPEN_LINK = '/manual/index.html';
const DOWNLOAD_NAME = 'Harmony-QMS-Operators-Manual.pdf';

function megabytes(bytes: number): string {
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

export default function HelpPage() {
  return (
    <PageContainer title="Help" maxWidth="md">
      <p className={styles.intro}>
        The Operator&rsquo;s Manual explains how Harmony QMS works: what each role sees, what each
        action does and leaves behind, and what to do when something looks wrong. Every example in
        it is synthetic.
      </p>

      <Card variant="outlined" padding="lg" className={styles.card}>
        <h2 className={styles.cardTitle}>{manual.title}</h2>
        {manual.edition && <p className={styles.edition}>{manual.edition}</p>}
        <div className={styles.actions}>
          <a
            className={`${buttonStyles.button} ${buttonStyles.primary} ${buttonStyles.md}`}
            href={OPEN_LINK}
            target="_blank"
            rel="noopener"
          >
            Open the manual
          </a>
          <a
            className={`${buttonStyles.button} ${buttonStyles.secondary} ${buttonStyles.md}`}
            href={manual.pdf.path}
            download={DOWNLOAD_NAME}
          >
            Download the PDF
          </a>
          <span className={styles.size}>PDF, {megabytes(manual.pdf.bytes)}</span>
        </div>
      </Card>

      <p className={styles.note}>
        The manual opens in a new tab. If something in it doesn&rsquo;t match what you see in the
        dashboard, tell Andy.
      </p>
    </PageContainer>
  );
}
